import React from 'react';
import { useParams } from 'react-router-dom';
import TicketPrinter from '../TicketPrinter';

const TicketPrinterWrapper = () => {
  const { id } = useParams();
  return <TicketPrinter ventaId={id} />;
};

export default TicketPrinterWrapper;
